import './form-travel-voucher.scss';

import { TravelVoucherFormSchema } from "@factory/form/form.rule";
import CheckboxControl from "@shared/ui/hook-form/checkbox-control/checkbox-control";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDateControl from "@shared/ui/hook-form/input-date-control/input-date-control";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import { useFormContext } from "react-hook-form";

type InputFormSchema = TravelVoucherFormSchema;
export function FormTravelVoucher() {
  const { control } = useFormContext<TravelVoucherFormSchema>();
  return (
    <div id="FormTravelVoucher" className="travel-voucher">
      <InputControl<InputFormSchema>
        control={control}
        name="baseInvoice"
        label="Base Invoice"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter baseInvoice"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="confirmationNum"
        label="Confirmation Num"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter confirmationNum"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="paymentCompletion"
        label="Payment Completion"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter paymentCompletion"
      />
      <CheckboxControl<InputFormSchema>
        control={control}
        name="isFullyPaid"
        label="Is Fully Paid"
        containerClassName="pb-2"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="amountPaid"
        label="Amount Paid"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter amountPaid"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="amount"
        label="Amount"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter amount"
      />
    </div>
  );
}

export default FormTravelVoucher;